// extracted by mini-css-extract-plugin
export default {"sign-up":"style_sign-up__tA93G","btnHolder":"style_btnHolder__0DMKF"};